<ng-container *transloco="let t">
    <div class="modal-header">
        <h5 class="modal-title">{{t("Internal linking modal title (Template/Document section) - Internal linking")}}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>


    <div class="modal-body px-0">
        <!-- Search -->
        <div class="my-1 px-2">
            <div class="input-group">
                <span class="input-group-text">
                    <i class="bi bi-search"></i>
                </span>
                <input type="text" class="form-control" [placeholder]="t('Search input placeholder (documents) - Search documents')" [(ngModel)]="searchTerm"
                    (ngModelChange)="searchDocuments()" />
            </div>
        </div>


        <app-skeleton section="documentslisting-Loader" *ngIf="loader"></app-skeleton>

        <!-- Listing -->
        <div class="table-responsive" *ngIf="documents?.length && !loader">
            <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                    <tr>
                        <th scope="col">{{ t("Document name (general) - Document name") }}</th>
                        <th scope="col" class="text-end"> {{ t("Status (general) - Status") }} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let doc of documents; index as i" (click)="selectDocument(doc)">
                        <td scope="row"> <app-document-column [dataItem]="doc"></app-document-column> </td>
                        <td class="text-end">
                            <app-document-status-badge [documentStatus]="doc.status"></app-document-status-badge>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>
</ng-container>